import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { useLicense } from '../context/LicenseContext';

const MODULE_LABELS = {
  reporting: 'Reporting COBAC',
  mad: 'MAD (Mise à disposition)',
  account_creator: 'Création de comptes',
};

const LicenseGate = ({ module, children }) => {
  const { isModuleLicensed, isAppBlocked, loading } = useLicense();

  if (loading) return null;

  if (isAppBlocked || !isModuleLicensed(module)) {
    const label = MODULE_LABELS[module] || module;
    return (
      <div className="max-w-2xl mx-auto px-6 py-16 text-center space-y-4">
        <ShieldX className="h-12 w-12 text-red-400 mx-auto" />
        <h2 className="text-lg font-semibold text-slate-800">Module non disponible</h2>
        <p className="text-sm text-slate-500">
          Le module <strong>{label}</strong> n&apos;est pas inclus dans votre licence actuelle.
          Contactez votre prestataire pour obtenir une licence incluant ce module.
        </p>
        <Link
          to="/license"
          className="inline-flex items-center gap-2 px-4 py-2 bg-[#E20613] text-white text-sm font-medium hover:bg-[#c90511] transition-colors"
        >
          Voir la licence
        </Link>
      </div>
    );
  }

  return children;
};

export default LicenseGate;
